export interface StpChartTokens {
  fontFamily: string
  fontSize: number
  textColor: string
  mutedColor: string
  borderColor: string
  splitLineColor: string
  palette: string[]
  lineWidth: number
}

export const stpChartTokens: StpChartTokens = {
  fontFamily: 'Rubik, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontSize: 12,
  textColor: '#1D2129',
  mutedColor: '#86909C',
  borderColor: '#E5E7EB',
  splitLineColor: '#E5E7EB',
  palette: ['#3D64E7', '#32B16C', '#F4B740', '#D96C9D'],
  lineWidth: 3,
}
